<template>
  <div class="merchants-logs-wrapper">
    <div class="merchants-logs-list" v-if="logData.length > 0">
      <template v-for="log in logData">
        <div class="list-item" :key="log.createdAt">
          <div class="list-item-date">{{ log.createdAt | date_time }} <span class="start-log" v-if="log.star">置顶</span></div>
          <div class="list-item-content" v-html="log.content"></div>
          <div class="list-item-footer">{{log.creatorName}} <span class="set-start" @click="onSetStart(log)">{{log.star ? '取消置顶' : '设为置顶'}}</span></div>
        </div>
      </template>
      <!-- <el-timeline>
        <el-timeline-item v-for="(log) in logData" :key="log.createdAt">
          <div class="log-content" v-html="log.content" :class="[log.showAll ? 'active' : '']"></div>
          <div class="log-show-more">
            <span class="text-primary" @click="log.showAll = !log.showAll">{{log.showAll ? '点击收起' : '点击展开'}}</span>
          </div>
          <div class="log-creator">{{log.creatorName}} {{log.createdAt | date}}</div>
        </el-timeline-item>
      </el-timeline> -->
    </div>
    <div class="no-list-data" v-if="logData.length <= 0">暂无跟进记录</div>

    <div class="pagenation-wrapper" v-if="logData.length > 0">
      <el-pagination
        class="pagenation"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSizes"
      ></el-pagination>
    </div>
    <div class="merchants-logs-edit-wrapper">
      <tinymce
        :toolbar="toolbar"
        v-model="content"
        :height="50"
        v-if="!submiting"
      />
      <div class="merchants-logs-edit-submit">
        <el-button size="small" :loading="submiting" @click="onSubmit">{{
          submiting ? "提交中..." : "提交跟进记录"
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import mtoolbar from "../js/toolbar";
import { PutMerchantsLogStarSwitch } from "../api";
export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      submiting: false,
      content: "",
      loading: false,
      currentId: null,
      logData: [],
      page: 0,
      size: 10,
      totalPages: 0,
      totalSizes: 0,
      toolbar: mtoolbar,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.currentId = this.$route.query.id;
      this.getMerchantsLogs(this.currentId);
    }
  },
  methods: {
    handleSizeChange(size) {
      this.page = 0;
      this.size = size ? size : this.size;
      this.getMerchantsLogs(this.currentId);
    },
    handleCurrentChange(Cpage) {
      this.page = Cpage ? Cpage - 1 : 0;
      this.getMerchantsLogs(this.currentId);
    },
    getMerchantsLogs(id) {
      this.loading = true;
      this.$api
        .get(`/merchants/${id}/follow_ups`, {
          params: {
            page: this.page,
            size: this.size,
          },
        })
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            let { content, totalPages, totalElements } = res.data;
            this.logData = content.map((item) => {
              return {
                ...item,
                showAll: false,
              };
            });
            this.totalPages = totalPages;
            this.totalSizes = totalElements;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error("数据获取失败", err.response);
          this.$notify.error({
            title: "数据拉取错误",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    onSubmit() {
      if (this.content === "") {
        this.$message.error("请先输入跟进内容！");
        return false;
      }
      this.submiting = true;
      this.$api
        .post(`/merchants/${this.currentId}/follow_ups`, {
          content: this.content,
        })
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.content = "";
            this.submiting = false;
            this.$message.success("提交成功!");
            this.page = 0;
            this.getMerchantsLogs(this.currentId);
          }
        })
        .catch((err) => {
          this.submiting = false;
          console.error("数据获取失败", err.response);
          this.$notify.error({
            title: "数据拉取错误",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    onSetStart(item){
      PutMerchantsLogStarSwitch(this.currentId, item.id).then(() => {
        this.$message.success("设置成功")
        this.getMerchantsLogs(this.currentId);
      }).catch((err) => {
          this.loading = false;
          console.error("设置失败", err.response);
          this.$notify.error({
            title: "设置失败",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.merchants-logs-wrapper {
  text-align: left;
  /deep/ {
    .mce-panel {
      box-sizing: border-box;
      border-width: 0px !important;
    }
    .el-timeline {
      padding: 0;
    }
  }
  .merchants-logs-edit-wrapper {
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 40px;
    padding-top: 20px;
    position: relative;
    .merchants-logs-edit-submit {
      box-sizing: border-box;
      width: 100%;
      text-align: right;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  $baseColor: #fff;
  .merchants-logs-list {
    padding: 15px 0;
    .list-item {
      box-sizing: border-box;
      position: relative;
      padding-left: 40px;
      margin-bottom: 20px;
      overflow: hidden;
      &::before {
        content: "";
        box-sizing: border-box;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 3px solid $baseColor;
        position: absolute;
        top: 0;
        left: 0;
      }
      &::after {
        content: "";
        box-sizing: border-box;
        width: 2px;
        height: 95%;
        background-color: $baseColor;
        position: absolute;
        top: 28px;
        left: 9px;
      }
    }
    .start-log{
      font-size: 12px;
      color: #000;
      padding: 2px 6px;
      text-align: center;
      border: 1px solid #333;
      border-radius: 2px;
      margin: 0 10px;
      cursor: pointer;
    }
    .list-item-date {
      width: 100%;
      padding-bottom: 10px;
      text-align: left;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .list-item-content{
      box-sizing: border-box;
      width: 100%;
      line-height: 30px;
      font-size: 14px;
      padding: 10px;
      background-color: $baseColor;
      border-radius: 2px;
    }
    .list-item-footer{
      box-sizing: border-box;
      font-size: 12px;
      text-align: left;
      padding: 10px;
      color: #989898;
      border-top: 1px solid #f1f1f1;
      background-color: $baseColor;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .set-start{
        color: #ccc;
        font-size: 13px;
        cursor: pointer;
        &:hover{
          color: #807e7e;
        }
      }
    }
  }
  .no-list-data {
    width: 100%;
    color: #989898;
    text-align: center;
    font-size: 14px;
    padding: 10px 0;
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
    /deep/ {
      // 页码列表的前后的按钮
      .el-pagination button {
        background-color: transparent;
      }
      .el-pagination button:disabled {
        background-color: transparent;
      }
      .el-pagination button:hover {
        color: #fff;
        background-color: #4c4948;
      }
      // 可选的页码列表
      .el-pager li {
        background-color: transparent;
      }
      .el-pager li:hover {
        color: #fff;
        background-color: #4c4948;
      }
      .el-pager li.active {
        color: #fff;
        background-color: #4c4948;
        cursor: default;
      }
      // 手动输入页数的输入框
      .el-pagination__editor.el-input .el-input__inner {
        background-color: transparent;
      }
      // 选择多少条每页的按钮
      .el-pagination .el-select .el-input .el-input__inner {
        background-color: transparent;
      }
    }
  }
}
</style>